import React from 'react';
import { Button, Modal, Icon, Table } from 'semantic-ui-react';
import './coletaDados.scss';
import { numFormat } from '@rededompedro/utils';

export default function Detalhes({ payment, details }) {
    const calcValue = details
        .map((detail) => detail.valor_total)
        .reduce((total, value) => total + value);

    const icon = calcValue === payment.valor_total ? 'check' : 'exclamation';
    return (
        <Modal
            trigger={
                <Button icon>
                    <Icon name="plus" />
                </Button>
            }
        >
            <Modal.Header>
                {payment.nome_empresa} - {payment.type}
            </Modal.Header>
            <Modal.Content>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Nome Frota</Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">Valor por Frota</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {details.map((detail) => {
                            return (
                                <Table.Row key={detail.cnpj_frota}>
                                    <Table.Cell>{detail.nome_frota}</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        R$ {numFormat(detail.valor_total)}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>

                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell>{details.length} detalhes</Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">
                                Valor total: R$
                                {numFormat(calcValue)}
                                <Icon className="checkIcon" name={icon} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </Modal.Content>
        </Modal>
    );
}
